import store from "./index"
import axios from 'axios';
import qs from "qs";

const api = axios.create({
  baseURL: window.env.baseUrl + "shop/api/",
  headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
});

function params(data) {
  return qs.stringify({
    '_csrf-frontend': window.yii.getCsrfToken(),
    ...data
  })
}

export const actions = {

  // ----------------------------------------------------------------------------------------------------------------
  // region LOAD DATA


  loadCart(context) {
    api.post('cart', params({}))
      .then(response => {
        context.commit('cartLoaded', response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  loadExtensions(context) {
    api.post('extensions', params({}))
      .then(response => {
        context.commit('loadShipments', response.data.shipments);
        context.commit('loadPayments', response.data.payments);
      })
      .catch(error => {
        console.error(error);
      });
  },

  // endregion

  // ----------------------------------------------------------------------------------------------------------------
  // region CART ITEM

  addItem(context, sku) {
    api.post('add-item', params({sku}))
      .then(response => {
        store.dispatch('loadCart');
      })
      .catch(error => {
        console.error(error);
      });
  },
  increase(context, sku) {

    let item = context.state.items[sku];
    if (typeof item === 'undefined') {
      return;
    }

    let increased = parseInt(item.qty) + 1;
    if (item.stock >= increased) {
      api.post('set-item-qty', params({sku, qty: increased}))
        .then(response => {
          context.commit('setItemQty', {sku, qty: increased});
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  decrease(context, sku) {
    let item = context.state.items[sku];
    if (typeof item === 'undefined') return;

    let decreased = parseInt(item.qty) - 1;
    if (decreased > 0) {
      api.post('set-item-qty', params({sku, qty: decreased}))
        .then(response => {
          context.commit('setItemQty', {sku, qty: decreased});
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  remove(context, sku) {
    let item = context.state.items[sku];
    api.post('remove-item', params({sku,}))
      .then(response => {
        context.commit('removeItem', sku);
      })
      .catch(error => {
        console.error(error);
      });
  },
  setItemQty(context, payload) {

    let item = context.state.items[payload.sku];
    let stock = item.stock;
    let qty = payload.value;
    if (qty > stock) {
      alert('Dostępna ilość: ' + stock);
      qty = stock;
      return;
    }
    api.post('set-item-qty', params({sku: payload.sku, qty}))
      .then(response => {
        context.commit('setItemQty', {sku: payload.sku, qty: qty});
      })
      .catch(error => {
        console.error(error);
      });
  },
  // endregion

  // ----------------------------------------------------------------------------------------------------------------
  // region SHIPMENT

  setShipment(context, internal_name) {

    let selectedShipment = context.state.shipments.find(item => {
      return item.internal_name === internal_name;
    });

    if (typeof selectedShipment !== 'undefined') {
      api.post('set-shipment', params({'order_id': context.state.order_id, internal_name: internal_name}))
        .then(response => {
          context.commit('setSelectedShipment', response);
        })
        .catch(error => {
          console.error(error);
        });
    }
    // nie znaleziono - uwuamy wybór
    else {
      api.post('unset-shipment', params({'order_id': context.state.order_id}))
        .then(response => {
          context.commit('unsetShipment', response);
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  // endregion

  // ----------------------------------------------------------------------------------------------------------------
  // region PAYMENT

  setPayment(context, internal_name) {

    let selectedPayment = context.state.payments.find(item => {
      return item.internal_name === internal_name;
    });

    if (typeof selectedPayment !== 'undefined') {
      api.post('set-payment', params({'order_id': context.state.order_id, internal_name: internal_name}))
        .then(response => {
          context.commit('setSelectedPayment', response);
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  // endregion

  // ----------------------------------------------------------------------------------------------------------------
  // region DISCOUNT

  setDiscountCode(context, payload) {

    api.post('discount-code', params({
      code: payload.code,
      orderId: context.state.order_id
    }))
      .then(response => {
        if (typeof response.data === 'object') {
          if ('id' in response.data ) {
            store.commit('setDiscountCode', response.data);
          }
        }

      })
      .catch(error => {
        console.error(error);
        store.dispatch('loadCart');
      });
  },
  removeDiscount(context) {

    api.post('remove-discount', params({
      id: context.state.discount.id,
      orderId: context.state.order_id
    }))
      .then(response => { store.commit('removeDiscount'); })
      .catch(error => {
        console.error(error);
      });
  },
  // endregion

  // region ALERTS
  removeAlert(context, payload) {
    store.commit('removeAlert',payload);
  },
  // endregion

  // region ADDRESSES
  loadAddresses(context) {
    api.post('order-addresses', params({}))
      .then(response => { store.commit('loadAddresses',response.data); })
      .catch(error => {
        console.error(error);
      });
  },
  // endregion

  // region COMMENT
  loadComment(context) {
    api.post('order-comment', params({}))
      .then(response => {
        store.commit('loadComment',response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },
  setApprovedProcessing(context, isApproved)
  {
    api.post('set-approvement', params({type: 'processing', isApproved}))
      .then(response => {
        store.commit('approvedProcessing',isApproved);
      })
      .catch(error => {
        console.error(error);
      });

  },
  setApprovedMarketing(context, isApproved)
  {
    api.post('set-approvement', params({type: 'marketing', isApproved}))
      .then(response => {
        store.commit('approvedMarketing',isApproved);
      })
      .catch(error => {
        console.error(error);
      });
  },
  setApprovedMailing(context, isApproved)
  {
    api.post('set-approvement', params({type: 'mailing', isApproved}))
      .then(response => {
        store.commit('approvedMailing',isApproved);
      })
      .catch(error => {
        console.error(error);
      });

  },
  setApproved(context, approvals)
  {
    api.post('set-approvement-update', params({approvals}))
      .then(response => {
        // store.commit('approvals', approvals);
      })
      .catch(error => {
        console.error(error);
      });

  },
  // region COMMENT
  saveComment(context, payload) {
    api.post('save-order-comment', params({comment: payload}))
      .then(response => {
        store.commit('saveComment', response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }
  //
};



// WEBPACK FOOTER //
// ./src/store/actions.js